// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3GT7U","wrapper":"style_wrapper__1the2"};